<template>
  <div class="wrapp">
    <div class="title">订单： 董东钰 的拍照订单 套系名称：尊享会员一对一</div>
    <div class="photo-class">
      <div class="item" v-for="(item,index) in photoCount" :key="index">
        {{item.text}}
        <span>{{item.num}}</span>张
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    photoCount: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapp {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 233, 233, 1);
  padding: 24px 24px 26px 24px;
  margin: 30px 30px;
  .title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(51, 60, 72, 1);
  }
  .title::before {
    content: " ";
    width: 4px;
    height: 24px;
    background: rgba(27, 36, 49, 1);
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }
  .photo-class {
    margin-top: 22px;
    font-size: 14px;
    color: $text-grey;
    .item {
      display: inline-block;
      padding: 0 24px;
      border-right: 1px solid #e2e2e2;
      span {
        color: $text-red;
      }
    }
    .item:last-child {
      border: none;
    }
  }
}
</style>
